
import { getLTDReportURL } from "../../apiclients/streamsapi_bridge";



export async function handleAnalyticsAction(navigate, windowsMap) {
    try {
        const session = sessionStorage.getItem("admin_session");
        if (!session) {
            console.error("Session data not found");
            navigate("/");
            return;
        }

        const siteId = JSON.parse(session).siteid;
        const response = await getLTDReportURL(siteId);

        if (!response.ok) {
            const message = `An error has occurred: ${response.statusText}`;
            console.error(message);
            return;
        }

        const rawData = await response.json();
        if (!rawData || !rawData.ltdloginurl) {
            window.alert("LTD Report URL not found");
            navigate("/");
            return;
        }

        const windowName = "LTDReport";

        // Check if the window with this name already exists
        if (
            windowsMap[windowName] &&
            !windowsMap[windowName].closed
        ) {
            // Focus on the existing window if it's already open
            windowsMap[windowName].focus();
            windowsMap[windowName].location.reload(); // Reload the window content
        } else {
            // Open a new window and store its reference in windowsMap
            windowsMap[windowName] = window.open(
                rawData.ltdloginurl,
                windowName
            );
        }
        window.location.reload();
    } catch (error) {
        console.error("Error fetching LTD Report:", error);
        navigate("/");
    }
}
